export const validateGroupName = (name: string) => {
  switch (name) {
    case 'lojasIds':
      return 'lojasIds'
    case 'produtosIds':
      return 'produtosIds'
    case 'pedidosIds':
      return 'pedidosIds'
    case 'tiposProcessos':
      return 'tiposProcessos'
    case 'centerTypes':
      return 'centerTypes'
    case 'fornecedoresIds':
      return 'fornecedoresIds'
    case 'usuariosIds':
      return 'usuariosIds'

    default:
      return null
  }
}
